import * as React from 'react';
import './adminMenuPage.scss';
import {DropDownRouteData} from "../../../navigation/route/HeaderRoutes";
import IconLarge from "../../../hiberUiKit/src/atoms/Icon/IconLarge";

interface ComponentProps {
	categoryName: string,
	menuItems: DropDownRouteData[],
	onItemClick: (url: string) => void,
	menuIcon: string,
}

const AdminMenuTile: React.SFC<ComponentProps> = ({categoryName, menuItems, onItemClick, menuIcon}) => {
	return (
		<div className="menu-tile">
			<div className="tile-header">
				<IconLarge
					icon={menuIcon}
					variant={"blue"}/>
				<p className="category-name">{categoryName}</p>
			</div>
			<ul className="tile-body">
				{menuItems.map((item, index) => (
					<li className="list-item" key={index} onClick={() => onItemClick(item.route)}>
						{item.label}
					</li>
				))}
			</ul>
		</div>
	);
};

export default AdminMenuTile;
